<template>
  <div class="py-4">
    <div class="color-black-1 font-18">{{ $t('answerSecurityQuestion') }}</div>
    <div class="mt-3">
      <validation-observer ref="formRef" v-slot="{}" tag="form">
        <validation-provider rules="required" v-slot="{ errors }">
          <custom-form-input
            v-model="model.token"
            type="number"
            :label="`${$t('TokenNumber')}:`"
            icon="user-circle"
            :error="errors[0]"
            :custom-error-msg="`${$t('RequiredField')}.`"
          />
        </validation-provider>
      </validation-observer>
    </div>
  </div>
</template>

<script>
import { CustomFormInput } from '@/components/common';
export default {
  name: 'UserProfile',
  components: {
    CustomFormInput,
  },
  data: () => ({
    model: {
      token: null,
    },
  }),
  methods: {
    getModel() {
      return { ...this.model };
    },
    async validate() {
      return await this.$refs.formRef.validate();
    },
  },
};
</script>
